import React from 'react';
import { JdsTag } from '../../../components/jds/JdsTag';

const OFFER_STATUS_TAGS = {
  paid: { label: 'Pago', color: 'info' },
  active: { label: 'Ativo', color: 'success' },
  expired: { label: 'Expirado', color: 'error' },
};

// Mesma regra do backend (jussub): expirado = expiredAt (expirar manual) ou
// expirationDate vencida. Pago (paidAt) vem antes: link pago não está "ativo".
export function getOfferStatus(offer) {
  if (offer?.paidAt) return 'paid';
  if (offer?.expiredAt) return 'expired';
  if (offer?.expirationDate && new Date(offer.expirationDate) < new Date())
    return 'expired';
  return 'active';
}

export function OfferStatusBadge({ offer }) {
  const { label, color } = OFFER_STATUS_TAGS[getOfferStatus(offer)];

  return <JdsTag label={label} color={color} dot />;
}
